import { BaseHubOptions } from "@gp/hub";

export class BetBoosterHubOptions extends BaseHubOptions {
	name: string = "bet-booster";
	commonEventNames: string[] = ["ChannelUpdates"];
}
